type Translate = (key: string, options?: Record<string, unknown>) => string;

function parseParams(
  params?: Record<string, unknown> | string | null
): Record<string, unknown> {
  if (params == null) {
    return {};
  }
  if (typeof params === "string") {
    try {
      const parsed = JSON.parse(params);
      return parsed && typeof parsed === "object" ? parsed : {};
    } catch {
      return {};
    }
  }
  return params;
}

/**
 * Resolves recommendation-generated copy from key+params when present,
 * otherwise falls back to the legacy Spanish string.
 */
export function formatRecommendationMessage(
  t: Translate,
  key: string | null | undefined,
  params: Record<string, unknown> | string | null | undefined,
  fallback?: string | null
): string {
  if (key) {
    const parsed = parseParams(params);
    const { detail, ...rest } = parsed;
    const base = String(t(key, rest));
    if (detail != null && String(detail).trim() !== "") {
      return `${base} (${detail})`;
    }
    return base;
  }
  return fallback ?? "";
}
